/**
 * https://react-redux.js.org/api/hooks#useselector
 */
import {useSelector} from "react-redux";
import {Tenant} from "core/models/Tenant";

const getTenant = (state: any): Tenant => state.user.tenant

export default function  useTenant(): Tenant{
  return useSelector(getTenant)
}
